import React, { useState } from 'react';
import { HelpCircle, ChevronDown, ChevronUp } from 'lucide-react';
import { useCaseFAQ } from '../data/mockData';

const UseCaseFAQ = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <section id="faq" className="py-16 bg-white relative overflow-hidden">
            {/* Decorative Elements */}
            <div className="absolute bottom-0 right-0 w-96 h-96 bg-accent/5 rounded-full translate-y-1/2 translate-x-1/2"></div>

            <div className="container mx-auto px-4 relative z-10">
                {/* Section Header */}
                <div className="text-center mb-12">
                    <div className="flex items-center justify-center gap-3 mb-4">
                        <HelpCircle size={32} className="text-accent" />
                        <h2 className="text-4xl lg:text-5xl font-bold text-gray-900">
                            Fabric Selection Guide
                        </h2>
                    </div>
                    <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                        Find the perfect fabric for your manufacturing needs. Expert recommendations for garment manufacturers and bulk buyers.
                    </p>
                </div>

                {/* FAQ Accordion */}
                <div className="max-w-4xl mx-auto space-y-4">
                    {useCaseFAQ.map((faq, index) => (
                        <div
                            key={index}
                            className="bg-gray-50 rounded-xl overflow-hidden border-2 border-gray-100 hover:border-primary transition-all duration-300"
                        >
                            <button
                                onClick={() => toggleFAQ(index)}
                                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-100 transition-colors"
                            >
                                <h3 className="text-lg font-semibold text-gray-900 pr-4">
                                    {faq.question}
                                </h3>
                                {openIndex === index ? (
                                    <ChevronUp size={24} className="text-primary flex-shrink-0" />
                                ) : (
                                    <ChevronDown size={24} className="text-gray-400 flex-shrink-0" />
                                )}
                            </button>

                            {openIndex === index && (
                                <div className="px-6 pb-5">
                                    <div className="pt-2 border-t border-gray-200">
                                        <p className="text-gray-700 leading-relaxed mt-3">
                                            {faq.answer}
                                        </p>

                                        {/* Hidden SEO Keywords */}
                                        <div className="sr-only" aria-hidden="true">
                                            {faq.keywords}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    ))}
                </div>

                {/* Bottom CTA */}
                <div className="text-center mt-12 p-8 bg-gradient-to-r from-primary/5 to-accent/5 rounded-2xl">
                    <h3 className="text-2xl font-bold text-gray-900 mb-3">
                        Still not sure which fabric to choose?
                    </h3>
                    <p className="text-gray-600 mb-6">
                        Our fabric experts are here to help. Contact us for personalized recommendations and bulk pricing.
                    </p>
                    <a
                        href={`https://wa.me/919713889720?text=${encodeURIComponent('I need help choosing the right fabric for my manufacturing needs')}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn-primary btn-lg inline-flex items-center gap-2"
                    >
                        Get Expert Advice
                    </a>
                </div>
            </div>
        </section>
    );
};

export default UseCaseFAQ;
